import _ from 'lodash';

const CONVERSIONS = {
	TOP_PROPERTY: {
		STRING: function (result, prop, value) {
			if (_.isString(value) && value.length) {
				result[prop] = value;
				return true;
			}
			return false;
		},
		NUMBER: function (result, prop, value) {
			if (_.isNumber(value)) {
				result[prop] = value;
				return true;
			}
			return false;
		},
		OBJECT: function (result, prop, value) {
			if (_.isObject(value)) {
				result[prop] = value;
				return true;
			}
			return false;
		},
		ARRAY: function (result, prop, value) {
			if (_.isArray(value)) {
				result[prop] = value;
				return true;
			}
			return false;
		},
		BOOLEAN: function (result, prop, value) {
			if (_.isBoolean(value)) {
				result[prop] = value;
				return true;
			}
			return false;
		},
		UNDEFINED: function (result, prop, value) {
			if (value === undefined) {
				result[prop] = value;
				return true;
			}
			return false;
		}
	}
};

const knownProperties = {
	message: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	},
	/* {message, file, line column, stack, messageType} custom created object with error related properties */
	error: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null, arguments);
	},
	errorId: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null, arguments);
	},
	/* details for error log */
	errorDetails: function (result, prop, value) {
		if (_.isObject(value)) {
			try {
				result[prop] = JSON.stringify(value);
			} catch (e) {
				result[prop] = `JSON.stringify could not serialize object: ${e.message}`;
			}
			return true;
		}
		return false;
	},
	errorHistory: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.ARRAY.apply(null, arguments);
	},
	// P9052-20271 this should always be JSON and not JSON.stringified to not make conflict with mw details key
	// If object needs to be stringified then use additionalData below
	details: function (result, prop, value) {
		if (_.isObject(value)) {
			result[prop] = value;
			return true;
		}
		return false;
	},
	// details field but stringified
	additionalData: function (result, prop, value) {
		if (_.isObject(value)) {
			try {
				result[prop] = JSON.stringify(value);
			} catch (e) {
				result[prop] = `JSON.stringify could not serialize object: ${e.message}`;
			}
			return true;
		}
		return false;
	},
	visualisers: function (result, prop, value) {
		if (_.isObject(value)) {
			result[prop] = value;
			return true;
		}
		return false;
	},
	tag: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	},
	miscellaneous: function (result, prop, value) {
		result.miscellaneous = result.miscellaneous || {};
		result.miscellaneous[prop] = value;
		return true;
	},
	user: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null, arguments);
	},
	clientId: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	},
	name: function (result, prop, value) { // componentName
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments) ||
		CONVERSIONS.TOP_PROPERTY.UNDEFINED.apply(null, arguments);
	},
	meta: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null, arguments);
	},
	isSignedIn: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.BOOLEAN.apply(null, arguments);
	},
	isRetry: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.BOOLEAN.apply(null, arguments);
	},
	previousMessage: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	},
	previousMessageId: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null, arguments);
	},
	firstMessage: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	},
	firstMessageId: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null, arguments);
	},
	serverStatus: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null, arguments);
	},
	apiErrorId: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null, arguments);
	},
	apiErrorKey: function (result, prop, value) {
		return CONVERSIONS.TOP_PROPERTY.STRING.apply(null, arguments);
	}
};

export default knownProperties;


// WEBPACK FOOTER //
// ./src/errors/knownproperties.js